/* eslint-disable max-len */
export const Register = "/account/Signup";
export const Login = "/account/SignInSignup";
export const SignOut = "/api/account/sign-out";
export const ExternalLogin = "/account/ExternalLogin";
export const ExternalRegister = "/account/ExternalRegister";
export const ExternalLoginCallback = "/account/ExternalLoginCallback";
export const ForgotPassword = "/account/ForgotPassword";
export const ResetPassword = "/account/ResetPassword";
export const Confirm = "/account/Confirm";
export const Consents = { url: "/api/account/Consents/%7BconsentScreenType%7D", type: undefined as { consentScreenType: string | number; } };
export const LoginOrRegistration = "/api/account/LoginOrRegistration";
export const BrowserFingerprint = "/api/account/bfp";
export const OnetExternal = "/account/OnetExternal";
export const ChangePassword = "/api/account/ChangePassword";
export const GenerateOnetUrl = "/account/GenerateOnetUrl";
